<template>
    <div class="pilih-program">
    <SOSlotBase
        :container-name="`pilih-program-oai`"
        :loading="isLoading">

        <template v-slot:title-bar>
            <SOTitleBar
                :page-title="'Pilih Program'"
                :type="'back'"
                @back="back"
            />
        </template>

        <template v-slot:content>
        <br>
        <div class="p-x-20">

            <div class="f-18 f-bold">
                <p>
                    Informasi Training
                </p>
            </div>
            <div class="form-field d-grid-1">
                <form class="pilih-program">
                    <div class="form-group">
                        <div class="p-t-16">
                            <label class="f-regular f-16 f-c-midgrey remove-margin require">Nama Program</label>
                            <input
                                type="text"
                                class="form-control inputs"
                                id="text_field"
                                aria-describedby="emailHelp"
                                value="Training Offline - All-In"
                                readonly
                                style="color: black; width: 100%"
                            />

                            <template>
                                <div class="font-14 f-regular text-start mar-top-16 text-gray">
                                    Pilih Jadwal <span class="text-blue">*</span>
                                </div>

                                <div class="card" @click="navigateToPilihJadwal">
                                <div class="row remove-margin card-detail">
                                <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
                                    <div class="font-14 text-name color-6f7">
                                        Jadwal Training
                                    </div>
                                    <div class="text-name f-18 f-bold">Belum Pilih Tanggal</div>
                                </div>
                                <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                        <path d="M15.3998 10.3801L10.8098 5.79006C10.6224 5.60381 10.369 5.49927 10.1048 5.49927C9.84062 5.49927 9.58716 5.60381 9.3998 5.79006C9.30607 5.88302 9.23168 5.99362 9.18091 6.11548C9.13014 6.23734 9.104 6.36805 9.104 6.50006C9.104 6.63207 9.13014 6.76278 9.18091 6.88464C9.23168 7.0065 9.30607 7.1171 9.3998 7.21006L13.9998 11.7901C14.0935 11.883 14.1679 11.9936 14.2187 12.1155C14.2695 12.2373 14.2956 12.368 14.2956 12.5001C14.2956 12.6321 14.2695 12.7628 14.2187 12.8846C14.1679 13.0065 14.0935 13.1171 13.9998 13.2101L9.3998 17.7901C9.2115 17.977 9.10518 18.2312 9.10425 18.4965C9.10331 18.7619 9.20783 19.0168 9.3948 19.2051C9.58178 19.3934 9.8359 19.4997 10.1013 19.5006C10.3666 19.5016 10.6215 19.397 10.8098 19.2101L15.3998 14.6201C15.9616 14.0576 16.2772 13.2951 16.2772 12.5001C16.2772 11.7051 15.9616 10.9426 15.3998 10.3801Z" fill="#595959"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <br>
                        <hr>
                        <br>
                        <div class="f-18 f-bold">
                            <p>
                            Informasi User
                            </p>
                        </div>

                        <SOInputRegular
                                :title="'Nama Owner'"
                                :validation="'alphanumeric'"
                                :required="true"
                                :placeholder="'Lila Lalita'"
                            />
                        </template> 
                        <br> 
                        <template>
                            <div class="form-group">
                                <label class="remove-margin font-14 color-8080 require" for="telpoutlet">No. Telephone</label>
                                <div class="input-group remove-padding mod">
                                <vue-country-code
                                    @onSelect="onSelect" :preferredCountries="['id', 'my', 'bn']">
                                </vue-country-code>
                                <input type="tel" class="form-control inputs" id="telpoutlet"
                                    v-model="edittelp" v-on:keyup="nomorWaOnkeyup"
                                >
                            </div>
                            </div>
                            <button class="btn btn-primary btn-long btnlnjt"
                                :disabled="isButtonDisabled"
                                :class="{ 'btn-disabled': isButtonDisabled }"
                                >
								    Lanjutkan
				                </button>
                        </template>  

                        </div>
                    </div>
                </form>
            </div>

        </div>
        </template>


    </SOSlotBase>
    </div>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";

export default {
    name: 'PilihProgramFree',
    components: {
        SOSlotBase,
        SOTitleBar,
        SOInputRegular
    },
    data() {
    return {
      isButtonDisabled: true,
      isLoading: false,
      edittelp: "",
      nomorWaOnkeyup: "",
      onSelect: false
    };
  },
  
    methods: {
    back() {
      this.$router.go(-1);
    },
    navigateToPilihJadwal() {
      this.$router.push({ name: 'pilihJadwalOAI' });
    },
  },
}


</script>

<style scoped>
.belajar-bersama-smartlink .separator {
    width: unset;
}
.d-flex-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.text-container {
    display: flex;
}

.text-container .epayment-container {
    width: 121px;
}
.text-container .reminder-container {
    width: 71px;
}


.card {
 padding: 16px;
}
.text-blue {
    color: #206CFF;
}

.text-gray {
    color: #6F7287;
}

.divider-line {
    display: flex;
    width: 320px;
    height: 4px;
    padding: 2px 0;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
}
.icon-container {
 align-items: end;
}

.btnlnjt {
    margin-top: 7rem;
    background-color: #206CFF;
    color: white;
}

.btn-disabled {
  background-color: #ccc;
  color: #f6f6f6;
}
</style>